module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }